import React from "react";

import './ProductViewer.css';
import { t } from "i18next";
import ImageGrid, { ImageGridProps } from "../../components/imagegrid/ImageGrid";
import { Link } from "react-router-dom";

export interface ProductViewerProps extends ImageGridProps {
    banner: string;
}

const ProductViewer = (props: ProductViewerProps) => {
    return (
        <div className="product-viewer">
            <div className='banner' >
                <img className='product-viewer-banner' src={props.banner} />
            </div>
            <ImageGrid
                data={props.data}
            />
            <Link to={'https://wa.link/gj0idh'} target={'_blank'} rel={'noopener noreferrer'} className='contact-us-button' >{t('products.common.contact')}</Link>
        </div>
    );
}

export default ProductViewer;
